import { YesNoAllOptions } from '~constants/maps';

import { SearchProps } from '~components/form-fields/search';

import { SahService } from '~lookups/models';

import { ServiceTypeRow } from '~appointments/reducers/serviceTypes';

const ORIGIN_OPTIONS = [
  { id: 'appointment', name: 'Appointment' },
  { id: 'invoice', name: 'Invoice' },
  { id: 'manual', name: 'Manual' },
];

interface SearchFieldsParams {
  sahServices: SahService[];
  serviceTypes: ServiceTypeRow[];
}

export const searchFields = ({ sahServices, serviceTypes }: SearchFieldsParams): SearchProps => ({
  show_errors: {
    defaultShow: true,
    type: 'lookup',
    field: 'show_errors',
    caption: 'Show errors?',
    placeholder: 'All',
    options: YesNoAllOptions,
  },
  show_ignored: {
    defaultShow: true,
    type: 'lookup',
    field: 'show_ignored',
    caption: 'Show ignored?',
    placeholder: 'All',
    options: YesNoAllOptions,
  },
  reference: {
    defaultShow: false,
    type: 'text-like',
    field: 'reference',
    caption: 'Reference',
    placeholder: 'Reference',
  },
  origin_tag: {
    defaultShow: false,
    type: 'lookup',
    field: 'origin_tag',
    caption: 'Origin',
    placeholder: 'All',
    options: ORIGIN_OPTIONS,
  },
  client: {
    defaultShow: false,
    type: 'text-like',
    field: ['client.first_name', 'client.surname', 'client.full_name'],
    caption: 'Client Name',
    placeholder: 'Client',
  },
  service_date: {
    defaultShow: false,
    type: 'date-range',
    field: 'service_date',
    caption: 'Service Date',
  },
  sah_service_id: {
    defaultShow: false,
    type: 'multi-lookup',
    field: 'sah_service_id',
    caption: 'SaH Service',
    placeholder: 'All',
    options: sahServices,
  },
  service_type_id: {
    defaultShow: false,
    type: 'multi-lookup',
    field: 'service_type_id',
    caption: 'Service Type',
    placeholder: 'All',
    options: serviceTypes,
  },
});

export default searchFields;
